import React, { useState } from "react";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import moment from "moment";
import IconButton from "@mui/material/IconButton";
import Axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import Controls from "../Controls";
import SubDealerAddForm from "./SubDealerAddForm";
import Popup from "../../../../../components/Popup/Popup";
import defaultImg from "./defaultImg.png";
import { API_URL_ADMIN, API_URL_LMS, API_URL_UMS } from "../../../../../Constant/index";
import { RenderCellExpand } from "../../../../../components/datagridtooltip/DataGridToolTip";
import { getSubDealerAction } from "../../../../../_actions/subDealer.action";
import ExportExcelPopup from "../../../../../components/exportPopup/ExportExcelPopup";
import { DataFormat, DATE_FORMAT, DATE_TIME_FORMAT, millisecondsToStringDate, convertToCurrencyFormat } from "../../../../../_helpers/commonFunctions";
import DataGridProMUI from "../../../../../components/DataGrid/DataGridProMUI";
import { onExportExcel } from "../../../../../_helpers/exportExcel";
import { ToastContainer, toast } from 'react-toastify'
// import 'react-toastify/dist/ReactToastify.css'
import { isPermission, authorizedMessage } from "../../../../../_helpers/commonAPI";
import AuthorizedMessage from "../../../../../components/AuthorizedMessage";
import AuthLoader from "../../../../../components/AuthLoader";

const SubDealerList = (props) => {
  const [openPopup, setOpenPopup] = useState(false);
  const [isAddEdit, setIsAddEdit] = useState(false);
  // const [openEditPermissionPopup, setOpenEditPermissionPopup] = useState(null);
  // const [openDeleteContactPopup, setOpenDeleteContactPopup] = useState(null);
  const [recordForEdit, setRecordForEdit] = useState({});
  // const [recordForDelete, setRecordForDelete] = useState(null);
  const [headerName, setHeaderName] = useState("Add Sub Dealer");
  const dispatch = useDispatch();
  const subDealerState = useSelector((state) => state.subDealerLoyalty);
  const Domhistory = useHistory();
  const [openExportPopup, setOpenExportPopup] = useState(null);
  const [pageSize, setPageSize] = useState(25);
  const [searchedRows, setSearchedRows] = useState(null)
  const excelFormating = [
    { creationDate: "dateTime" },
    { pdpaConsentDate: "dateTime" },
  ];
  const excelDataTransformConfig = {
    markForDelete: { true: "Yes", false: "No" },
    eopCreationDate: true,
    pdpaStringDate: true,
  };
  const [legalForm, SetLegalForm] = useState([]);
  const [gridData, setGridData] = useState([]);
  const [province, setProvince] = useState([]);
  const [loading, setLoading] = React.useState(false)
  const [fileUrl, setFileUrl] = useState("");
  const [exportFiles, setExportFiles] = useState([])
  const [open, setOpen] = useState(false);
  const [exportState, setExportState] = useState("Export");
  const [state, setState] = React.useState({
    message: "",
    severity: "",
    open: false,
  });
  const [searchExpVal, setSearchExpVal] = useState("");
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [statusCode, setStatusCode] = useState(null)

  const setsrchVal = (val) => {
    setSearchExpVal(val)
  }

  const onExportClick = () => {
    const url = `export/subDealersExport`;
    // const url = `export/subDealersExport?search=`+searchExpVal.join(" ");
    setExportState("Exporting...");
    Axios({
      method: "GET",
      url: API_URL_ADMIN + url,
      // data: searchExpVal.join(" "),
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
        "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
      },
    })
      .then(async (response) => {
        setExportState("Export");
        setOpen(true);
        setFileUrl(response.data.data);
        exportExcelFile(response.data.data);
      })
      .catch((err) => {
        setExportState("Export");
      });
  };

  function exportExcelFile(file_url) {
    setExportFiles([]);
    Axios({
      method: "GET",
      url: API_URL_ADMIN + `export/bucket?folderName=${file_url}`,
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
        "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
      },
    })
      .then(async (response) => {
        const newRes = Array.isArray(response.data.data)
          ? response.data.data
          : [];
        setExportFiles(newRes);
      })
      .catch((err) => {
        // setExportState({ btnName: "EXPORT" });
      });
  }

  const columns = [
    {
      field: "actions",
      headerName: "Actions",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const onEditClick = async (e) => {
          const isAllow = await isPermission("RetailerSubDealerManagement-SubDealerManagementList-AddSubDealer-edit")
          if (!isAllow) {
            toast.success(authorizedMessage, {
              position: toast.POSITION.TOP_RIGHT
            });
            return 0;
          }
          setHeaderName("Edit Sub Dealer " + params.row.subDealerNumber);
          let rowData = params.row;
          rowData.markDelete = params.row && params.row.markForDelete;
          if (
            rowData &&
            rowData.groupCompany !== null &&
            rowData.groupCompany.includes("SCCC")
          ) {
            rowData.groupCompanySCCC = true;
          }
          if (
            rowData &&
            rowData.groupCompany !== null &&
            rowData.groupCompany.includes("SCCO")
          ) {
            rowData.groupCompanySCCO = true;
          }
          if (
            rowData &&
            rowData.groupCompany !== null &&
            rowData.groupCompany.includes("CONWOOD")
          ) {
            rowData.groupCompanyCONWOOD = true;
          }
          if (
            rowData &&
            rowData.groupCompany !== null &&
            rowData.groupCompany.includes("ISUB")
          ) {
            rowData.groupCompanyISUB = true;
          }
          if (
            rowData &&
            rowData.groupCompany !== null &&
            rowData.groupCompany.includes("IECO")
          ) {
            rowData.groupCompanyIECO = true;
          }
          setRecordForEdit(rowData);
          setOpenPopup(true);
        };

        return (
          <div className="Action">
            {/* <IconButton aria-label="delete">
            <DeleteIcon />
          </IconButton> */}
            <IconButton aria-label="edit">
              <EditIcon className="EditIcon" onClick={onEditClick} />
            </IconButton>
            {/* <EditIcon className="EditIcon" onClick={onEditClick} /> */}
          </div>
        );
      },
    },
    {
      field: "markForDelete",
      headerName: "Mark Delete",
      headerAlign: "center",
      align: "center",
      renderCell: ({ row }) => {
        return (
          <div className="MarkDelChkBox">
            <Controls.Checkbox value={row.markForDelete} />
          </div>
        );
      },
    },
    {
      field: "accountGroup",
      headerName: "Account Group",
      headerAlign: "center",
      align: "center",
      width: 150,
    },
    {
      field: "groupCompany",
      headerName: "Group Company",
      headerAlign: "center",
      align: "center",
      width: 250,
      renderCell: (row) => <RenderCellExpand align="center" {...row} />,
    },
    {
      field: "subDealerNumber",
      headerName: "Sub Dealer Number",
      headerAlign: "center",
      align: "center",
      width: 170,
      renderCell: ({ row }) => {
        return (
          <>{row.subDealerNumber ? DataFormat(row.subDealerNumber) : ""}</>
        );
      },
    },
    {
      field: "subDealerNameEN",
      headerName: "Sub Dealer Name (EN)",
      headerAlign: "center",
      align: "left",
      width: 250,
      renderCell: RenderCellExpand,
      renderCell: ({ row }) => {
        const redirectToContact = (e) => {
          e.preventDefault();
          Domhistory.push(
            "/SubDealerManagement?subDelearNumber=" +
            row.subDealerNumber +
            "&subDelearName=" +
            row.subDealerNameEN
          );
        };
        return (
          <a href="#" onClick={redirectToContact}>
            {row.subDealerNameEN}
          </a>
        );
      },
    },
    {
      field: "subDealerNameTH",
      headerName: "Sub Dealer Name (TH)",
      headerAlign: "center",
      align: "left",
      width: 250,
      renderCell: RenderCellExpand,
    },
    {
      field: "taxNumber",
      headerName: "Tax Number",
      headerAlign: "center",
      align: "center",
      width: 150,
      renderCell: (row) => <RenderCellExpand align="center" {...row} />,
    },
    {
      field: "legalFormData",
      headerName: "Legal Form",
      headerAlign: "center",
      align: "center",
      width: 250,
    },
    {
      field: "customerTierStatus",
      headerName: "Customer Tier Status",
      headerAlign: "center",
      align: "center",
      width: 150,
    },
    {
      field: "inseeLifeNumber",
      headerName: "INSEE LIFE Number",
      align: "right",
      headerAlign: "center",
      aligh: "center",
      width: 150,
      renderCell: (row) => <RenderCellExpand align="center" {...row} />,
    },
    {
      field: "inseeLifePoints",
      headerName: "INSEE LIFE Points",
      align: "right",
      headerAlign: "center",
      width: 160,
      format: '#,###.00',
      renderCell: ({ row }) => {
        return (
          <div>
            {row.inseeLifePoints != null
              ? convertToCurrencyFormat(row.inseeLifePoints)
              : "0.00"}
          </div>
        );
      },
    },
    {
      field: "thaiSmartCard",
      headerName: "Thai Smart Card",
      headerAlign: "center",
      align: "center",
      width: 150,
      renderCell: (row) => <RenderCellExpand align="center" {...row} />,
    },
    {
      field: "addressNumber",
      headerName: "Address Number",
      headerAlign: "center",
      align: "center",
      width: 150,
    },
    // ch
    {
      field: "province",
      headerName: "Province",
      headerAlign: "center",
      align: "center",
      width: 150,
    },
    {
      field: "district",
      headerName: "District",
      headerAlign: "center",
      align: "center",
      width: 150,
    },
    {
      field: "subDistrict",
      headerName: "Sub District",
      headerAlign: "center",
      align: "center",
      width: 150,
    },
    {
      field: "street",
      headerName: "Street",
      headerAlign: "center",
      width: 150,
      align: "center",
      renderCell: (row) => <RenderCellExpand align="center" {...row} />,
    },
    {
      field: "postalCode",
      headerName: "Postal Code",
      headerAlign: "center",
      align: "center",
      width: 150,
    },
    {
      field: "latitudeLongitude",
      headerName: "Latitude, Longitude ",
      headerAlign: "center",
      align: "center",
      width: 200,
      renderCell: (row) => <RenderCellExpand align="center" {...row} />,
    },
    {
      field: "salesDistrict",
      headerName: "Sales District",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "pdpaString",
      headerName: "PDPA",
      width: 150,
      headerAlign: "center",
      align: "center",
      // renderCell: ({ row }) => {
      //   return <>{row.pdpa === true || row.pdpa === "true" ? "Yes" : "No"}</>;
      // },
    },
    {
      field: "pdpaConsentDateMilliSeconds",
      headerName: "PDPA Consent Date/Time",
      width: 250,
      headerAlign: "center",
      align: "center",
      type: "date",
      format: 'DD-MM-yyyy HH:mm',
      valueFormatter: (row) => {
        return row.value && row.value !== null
          ? moment(new Date(row.value)).format("DD-MM-yyyy HH:mm")
          : "";
      },
    },
    {
      field: "email",
      headerName: "Email",
      width: 200,
      headerAlign: "center",
      align: "left",
      renderCell: (row) => <RenderCellExpand align="center" {...row} />,
    },
    {
      field: "phoneNumber",
      headerName: "Phone Number",
      headerAlign: "center",
      align: "center",
      width: 150,
    },
    {
      field: "mobile",
      headerName: "Mobile",
      headerAlign: "center",
      align: "center",
      width: 100,
    },
    {
      field: "customerImage",
      headerName: "Customer Image",
      headerAlign: "center",
      align: "center",
      width: 150,
      renderCell: ({ row }) => {
        return (
          <img
            className="user_image1"
            src={row.customerImage ? row.customerImage : defaultImg}
            alt="user"
          ></img>
        );
      },
    },
    {
      field: "createdBy",
      headerName: "Created By",
      headerAlign: "center",
      align: "left",
      width: 150,
      renderCell: RenderCellExpand,
    },
    {
      field: "creationDate",
      headerName: "Created Date/Time",
      width: 150,
      headerAlign: "center",
      align: "center",
      type: "date",
      format: 'DD-MM-yyyy HH:mm',
      valueFormatter: (row) => {
        return row.value && row.value !== null
          ? moment(new Date(row.value)).format("DD-MM-yyyy HH:mm")
          : "";
      },
    },
    { field: 'inLfPts', headerName: 'inLfPts', hide: true },
    { field: 'pdpaDt', headerName: 'pdpaDt', hide: true },
    { field: 'cDate', headerName: 'cDate', hide: true },
  ];


  function getLegalForm() {
    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
      },
    };
    Axios.get(API_URL_ADMIN + "retailer/legalForm", requestOptions).then(
      (response) => {
        SetLegalForm(response.data);
        return response;
      }
    );
  }
  function getprovince() {
    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
      },
    };
    Axios.get(API_URL_ADMIN + "metadata/TH/province", requestOptions).then(
      (response) => {
        setProvince(response.data);
        return response;
      }
    );
  }

  React.useEffect(() => {
    getLegalForm();
    getprovince();
    dispatch(getSubDealerAction());
  }, []);

  // formatting to standard miliseconds date
  const FormatMSDate = (IpDate) => {
    let OPDate = IpDate.toString().replace(/[^\w\s]/gi, '')
    if (OPDate.length < 13) {
      OPDate = OPDate.padEnd(13, '0')
    }
    return +OPDate
  }

  React.useEffect(() => {
    const gridData = subDealerState &&
      subDealerState.subdealerList &&
      subDealerState.subdealerList.data && subDealerState.subdealerList.data.map((item, index) => {
        const cdt = item.creationDate != null ? item.creationDate.toString().search(/\./) ? FormatMSDate(item.creationDate) : new Date(+item.creationDate) : "";
        return ({
          ...item,
          cDate: moment(new Date(cdt)).format("DD-MM-yyyy HH:mm"),
          creationDate: cdt,
          pdpaConsentDateMilliSeconds: item.pdpaConsentDateMilliSeconds != null ? new Date(item.pdpaConsentDateMilliSeconds) : "",
          pdpaString: item.pdpa === true || item.pdpa === "true" ? "Yes" : "No",
          legalFormData: item.legalFormName ? item.legalFormName : "",
          subDealerNumber: item.subDealerNumber != null ? +item.subDealerNumber : "",
          // taxNum: item.taxNumber != null ? +item.taxNumber : "",
          inseeLifeNumber: item.inseeLifeNumber != null && item.inseeLifeNumber != "" ? +item.inseeLifeNumber : "",
          thaiSmartCard: item.thaiSmartCard != null && item.thaiSmartCard != "" ? +item.thaiSmartCard : "",
          //mobile: item.mobile != null && item.mobile != "" ? +item.mobile : "",
          //phoneNumber: item.phoneNumber != null && item.phoneNumber != "" ? +item.phoneNumber : "",
          pdpaDt: item.pdpaConsentDateMilliSeconds != null ? moment(new Date(item.pdpaConsentDateMilliSeconds)).format("DD-MM-yyyy HH:mm") : "",
          inLfPts: convertToCurrencyFormat(item.inseeLifePoints),
        })
      })
    setGridData(gridData)
    console.log("fffffffffffff :", subDealerState)
    const sCode = subDealerState && subDealerState.errorMessage && subDealerState.errorMessage.status;
    setStatusCode(sCode)
  }, [subDealerState]);

  React.useEffect(() => {
    if (isAddEdit === true && openPopup === false)
      dispatch(getSubDealerAction());
  }, [isAddEdit, openPopup]);

  console.log("searchedRows=>", searchedRows)

  function modifyColumns(columns) {
    // columns = columns.filter(function(el) { return el.field != "actions"; });
    columns = columns.filter((item) => !["actions", "inLfPts", "pdpaDt", "cDate"].includes(item.field))
    return columns.map((item) => {
      return ({
        label: item.headerName,
        value: item.field,
        ...item
      })
    })
  }

  function modifyRows(rowdata) {
    // let filteredRow = searchedRows.map((item) => item.model);
    let filteredRow = rowdata.map((item) => item.model);
    const data = filteredRow.map((item) => {
      return ({
        ...item,
        creationDate: item.creationDate ? new Date(item.creationDate) : ""
      })
    })
    return data
  }

  function callExcelExport(data) {
    const fileName = `Subdealer_Management_Report_${moment(new Date()).format("DDMMyyyy")}`
    const sheetName = `Subdealer_Management`
    onExportExcel(modifyColumns(columns), modifyRows(data), fileName, sheetName)
  }

  function addSubdealer() {
    setIsButtonLoading(true)

    const userID = JSON.parse(localStorage.getItem("userData")).userId;

    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
      },
    };
    Axios.get(`${API_URL_UMS}/resources/checkAuthorization?userName=${userID}&permission=RetailerSubDealerManagement-Contact-AddContact-create`, requestOptions).then(
      (response) => {
        setIsButtonLoading(false)
        if (response.data === true) {
          setHeaderName("Add Sub Dealer");
          setOpenPopup(true);
          setRecordForEdit(null);
        } else {
          toast.success(authorizedMessage, {
            position: toast.POSITION.TOP_RIGHT
          });
        }
        return response;
      }
    );
  }

  return (
    <>
      {subDealerState.loading ? <AuthLoader /> : statusCode === 401 ? <AuthorizedMessage /> :
        <>
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={state.open}
            autoHideDuration={6000}
            key={"topright"}
          >
            <Alert
              severity={state.severity}
              sx={{ width: "100%" }}
              action={
                <Button
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setState({ open: false });
                  }}
                >
                  Close
                </Button>
              }
            >
              {state.message}
            </Alert>
          </Snackbar>
          <div className="ContactContainer">
            <div className="AddAndSearch justify-content-start">
              <Button
                variant="contained"
                className="AddContactBtn"
                onClick={() => addSubdealer()}
              >
                ADD SUB DEALER
              </Button>
              {/* {isButtonLoading && <span class="spinner-border spinner-border ml-1 mt-1 float-left" role="status" aria-hidden="true"></span>} */}
              {/* {!isButtonLoading && <span class="spinner-border spinner-border-sm ml-1 float-left" role="status" aria-hidden="true"></span>} */}
            </div>
            <ToastContainer />
          </div>
          <div className="DataGridContainer">

            <ExportExcelPopup
              title={"Customer"}
              fileName={"customer"}
              setOpen={setOpen}
              open={open}
              exportExcelFile={exportExcelFile}
              fileUrl={fileUrl}
              exportFiles={exportFiles}
            />
            <DataGridProMUI
              rows={
                gridData
                  ? gridData
                  : []
              }
              columns={columns}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              componentsProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
              loading={subDealerState.loading}
              onExportClick={onExportClick}
              exportState={exportState}
              setsrchVal={setsrchVal}
              setSearchedRows={setSearchedRows}
              callExcelExport={callExcelExport}
              defaultStateChange={false}
            />
          </div>

          {/* popup is a reusable custom dialog component */}
          <Popup
            title={headerName}
            openPopup={openPopup}
            setOpenPopup={setOpenPopup}
            width={"100%"}
            height={"100%"}
            pt={0}
            pb={0}
            pl={0}
            pr={0}
          >
            <SubDealerAddForm
              setOpenPopup={setOpenPopup}
              recordForEdit={recordForEdit}
              setIsAddEdit={setIsAddEdit}
            />
          </Popup>
        </>
      }
    </>
  );
};

export default withTranslation()(SubDealerList);
